// extracted by mini-css-extract-plugin
module.exports = {"pressReleaseIE11":"pressReleaseIE11__qetyn"};